import type { Provider } from '@angular/core';

import { DocumentLibraryListQueryStore } from '@shared/services/document-library/document-library-list-query.store';

import { DOCUMENT_LIBRARY_TRANSLOCO } from './document-library.transloco';
import { DocumentLibraryStore } from './stores/document-library.store';

export const DOCUMENT_LIBRARY_ROUTE_PROVIDERS: Provider[] = [
  DOCUMENT_LIBRARY_TRANSLOCO.provider,
  DocumentLibraryListQueryStore,
  DocumentLibraryStore,
];
